import {html} from 'lit';
import {selectSpcIsSatisfied} from '../selectors';

export const lineColumnBollard = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		isVisible: (state) => true,
		features: [
			'shared::ContextV3::CX_Region',
			'shared::ContextV3::CX_Usage',
			//'shared::ProductType::CX_ProductFamily',
			'shared::ProductType::HS_HousingType',
		],
		widgets: []
	},
	{
		id: 'lightdistribution',
		label: {
			de: 'Beleuchtungsart',
			en: 'Illumination Style',
			fr: 'Style d\'Éclairage',
		},
		visual: 'lightdistribution',
		isVisible: (state) => true,
		features: [
			'root::Poles::Pole::SpecialLine::HS_Construction',
		]
	},
	{
		id: 'lightengine',
		label: {
			de: 'Optik',
			en: 'Optics',
			fr: 'Optique',
		},
		visual: 'optics',
		isVisible: (state) => true,
		features: [
			'shared::PreFilter::LU_Filter_LightEmission_Uplight',
			'shared::PreFilter::LU_Filter_LightEmission_CA',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_CA',

			//'shared::Context::HS_LightEmission',
			//'shared::Context::HS_LightEmissionCAFilter',
			//'root::LightEngine_1::LE_UpLight',

			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightDistribution',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ColourTemperature',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ReflectorColour',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_OpticalVersion',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEngineModuleSize',
			'root::Heads::Head_2:Type::Luminaire::LightEngine::LE_LightEngineModuleSize',


			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LuminousFlux',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_ColourTemperature',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightDistribution',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LuminousFlux',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_OpticalVersion',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_ReflectorColour',
			//'root::Poles::Pole::SpecialLine::HS_HousingMountingLocationEBlock_2'
		],
		widgetsEnd_Debug: [
			html`<vertical-slider
				.title=${{de: 'Dimmstufe', en: 'Dimm Level', fr: 'Niveau de gradation'}}
				.isSatisfied= ${selectSpcIsSatisfied}
				action='decisions/setDimmLevel'
			></vertical-slider>`,
		]
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Poles::Pole::Basic::HS_Height',
			'root::Poles::Pole::ColourCoatingBase::HS_HousingColour',
			'root::Poles::Pole::ColourCoatingBase::HS_HousingCoating',
			'root::Poles::Pole::Basic::HS_Base',
			'root::Poles::Pole::Basic::HS_NumberPoleDoors',
			'root::Poles::Pole::SpecialLine::HS_HousingMountingLocationEBlock_1',
			'root::Poles::Pole::SpecialLine::HS_HousingMountingLocationEBlock_2',

			//'root::Heads::Head::EBlock::EB_EBlockMountingType',
			//'root::Heads::Head_2::EBlock::EB_EBlockMountingType',
			//'root::Heads::Head::Housing::HS_HousingShape',
			//'shared::HousingLuminaire::HS_HousingHeight',
		]
	},
	{
		id: 'electricblock',
		label: {
			de: 'Steuerung',
			en: 'Control',
			fr: 'Contrôle',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Heads::Head::EBlock::EB_Control',
			//'root::Heads::Head::EBlock::EB_ControlNoWire',
			//'root::Heads::Head::EBlock::EB_ControlWire',
			'root::Heads::Head::EBlock::EB_ElectricalProtectionClass',
			'root::Heads::Head::SmartControl::HS_HousingZhaga',
			'root::Heads::Head::EBlock::EB_ConstantLumenTechnology',
			//'root::Heads::Head_2::EBlock::EB_Control',
			//'root::Heads::Head_2::EBlock::EB_ControlNoWire',
			//'root::Heads::Head_2::EBlock::EB_ControlWire',
			//'root::Heads::Head_2::EBlock::EB_ElectricalProtectionClass',
			//'root::Heads::Head_2::EBlock::EB_ConstantLumenTechnology',
		]
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];
export const lineColumnIntern = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		isVisible: (state) => true,
		features: [
			'shared::ContextV3::CX_Region',
			'shared::ContextV3::CX_Usage',
			'shared::ProductType::HS_HousingType',
			//'root::CX_Region',
			'root::Poles::Pole::SpecialLine::HS_Construction',

			'shared::PreFilter::LU_Filter_LightEmission_Uplight',
			'shared::PreFilter::LU_Filter_LightEmission_CA',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_CA',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightEmission_CA',
		],
		widgets: []
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Poles::Pole::Basic::HS_Base',
			'root::Poles::Pole::Basic::HS_Height',
			'root::Poles::Pole::ColourCoatingBase::HS_HousingColour',
			'root::Poles::Pole::ColourCoatingBase::HS_HousingCoating',
			//'root::Heads::Head::Housing::HS_HousingShape',
			//'shared::HousingLuminaire::HS_HousingHeight',
			'root::Poles::Pole::Basic::HS_NumberPoleDoors',
			'root::HS_HousingPowerConnection',
			'root::HS_HousingPowerConnectionPosition',
			'root::HS_HousingMountingLocationEblock_1',
			'root::HS_HousingMountingLocationEblock_2',
		]
	},
	{
		id: 'lightengineA',
		label: {
			de: 'Optik A',
			en: 'Optics A',
			fr: 'Optique A',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ColourTemperature',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightDistribution',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LuminousFlux',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEngineModuleSize',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_OpticalVersion',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ReflectorColour',
		]
	},
	{
		id: 'lightengineB',
		label: {
			de: 'Optik B',
			en: 'Optics B',
			fr: 'Optique B',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_ColourTemperature',
			//'root::LightEngine_2::LE_DimmingLevel',
			'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightDistribution',
			'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LuminousFlux',
			'root::Heads::Head_2:Type::Luminaire::LightEngine::LE_LightEngineModuleSize',
			'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_OpticalVersion',
			'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_ReflectorColour',
		]
	},
	{
		id: 'electricA',
		label: {
			de: 'EBlock A',
			en: 'EBlock A',
			fr: 'EBlock A',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Heads::Head::EBlock::EB_ConstantLumenTechnology',
			'root::Heads::Head::EBlock::EB_Control',
			'root::Heads::Head::EBlock::EB_EBlockMountingType',
			'root::Heads::Head::EBlock::EB_ElectricalProtectionClass',
			'root::Heads::Head::EBlock::EB_Wattage',
			'root::Heads::Head::SmartControl::HS_HousingZhaga'
		]
	},
	{
		id: 'electricB',
		label: {
			de: 'EBlock B',
			en: 'EBlock B',
			fr: 'EBlock B',
		},
		visual: 'housing',
		features: [
			'root::Heads::Head_2::EBlock::EB_ConstantLumenTechnology',
			'root::Heads::Head_2::EBlock::EB_Control',
			'root::Heads::Head_2::EBlock::EB_EBlockMountingType',
			'root::Heads::Head_2::EBlock::EB_ElectricalProtectionClass',
			'root::EBlock_2::EB_Wattage',
		], // null
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];
export const lineBollardIntern = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		features: [
			'shared::ContextV3::CX_Region',
			'shared::ContextV3::CX_Usage',
			'shared::ProductType::HS_HousingType',
			'root::Poles::Pole::SpecialLine::HS_Construction',

			'shared::PreFilter::LU_Filter_LightEmission_Uplight',
			'shared::PreFilter::LU_Filter_LightEmission_CA',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_CA',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightEmission_CA',
		],
		widgets: []
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Poles::Pole::Basic::HS_Base',
			'root::Poles::Pole::Basic::HS_Height',
			'root::Poles::Pole::ColourCoatingBase::HS_HousingColour',
			'root::Poles::Pole::ColourCoatingBase::HS_HousingCoating',
			//'root::Heads::Head::Housing::HS_HousingShape',
			//'shared::HousingLuminaire::HS_HousingHeight',
			'root::Poles::Pole::Basic::HS_NumberPoleDoors',
			'root::HS_HousingPowerConnection',
			'root::HS_HousingPowerConnectionPosition',
			'root::HS_HousingMountingLocationEblock_1',
			'root::HS_HousingMountingLocationEblock_2',
		]
	},
	{
		id: 'lightengineA',
		label: {
			de: 'Optik A',
			en: 'Optics A',
			fr: 'Optique A',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ColourTemperature',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightDistribution',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LuminousFlux',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEngineModuleSize',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_OpticalVersion',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ReflectorColour',
		]
	},
	{
		id: 'lightengineB',
		label: {
			de: 'Optik B',
			en: 'Optics B',
			fr: 'Optique B',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_ColourTemperature',
			//'root::LightEngine_2::LE_DimmingLevel',
			'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightDistribution',
			'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LuminousFlux',
			'root::Heads::Head_2:Type::Luminaire::LightEngine::LE_LightEngineModuleSize',
			'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_OpticalVersion',
			'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_ReflectorColour',
		]
	},
	{
		id: 'electricA',
		label: {
			de: 'EBlock A',
			en: 'EBlock A',
			fr: 'EBlock A',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Heads::Head::EBlock::EB_ConstantLumenTechnology',
			'root::Heads::Head::EBlock::EB_Control',
			'root::Heads::Head::EBlock::EB_EBlockMountingType',
			'root::Heads::Head::EBlock::EB_ElectricalProtectionClass',
			'root::Heads::Head::EBlock::EB_Wattage',
			'root::Heads::Head::SmartControl::HS_HousingZhaga'
		]
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];

export const lineSingular = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		isVisible: (state) => true,
		features: [
			'shared::ContextV3::CX_Region',
			'shared::ContextV3::CX_Usage',
			'shared::ProductType::HS_HousingType',
		],
		widgets: []
	},
	{
		id: 'lightengine',
		label: {
			de: 'Optik',
			en: 'Optics',
			fr: 'Optique',
		},
		visual: 'optics',
		isVisible: (state) => true,
		features: [
			'shared::PreFilter::LU_Filter_LightEmission_Uplight',
			'shared::PreFilter::LU_Filter_LightEmission_CA',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_CA',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightEmission_CA',

			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightDistribution',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ColourTemperature',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LuminousFlux',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ReflectorColour',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_OpticalVersion',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEngineModuleSize',

			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_ColourTemperature',
			//'root::LightEngine_2::LE_DimmingLevel',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightDistribution',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LuminousFlux',
			//'root::Heads::Head_2:Type::Luminaire::LightEngine::LE_LightEngineModuleSize',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_OpticalVersion',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_ReflectorColour',
		],
		widgets: []
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			//'root::Poles::Pole::Basic::HS_Base',
			'root::Heads::Head::Housing::HS_HousingConnection',
			//'root::Poles::Pole::Basic::HS_Height',
			'root::Poles::Pole::ColourCoatingBase::HS_HousingColour',
			'root::Poles::Pole::ColourCoatingBase::HS_HousingCoating',
			//'root::Heads::Head::Housing::HS_HousingShape',
			//'shared::HousingLuminaire::HS_HousingHeight',
			//'root::Poles::Pole::Basic::HS_NumberPoleDoors',
			'root::HS_HousingMountingLocationEblock_1',
			'root::HS_HousingMountingLocationEblock_2',
			'root::Heads::Head::EBlock::EB_EBlockMountingType',
			//'root::Heads::Head::Housing::HS_HousingPowerConnection'
		],
		widgets: []
	},
	{
		id: 'electricblock',
		label: {
			de: 'Steuerung',
			en: 'Control',
			fr: 'Contrôle',
		},
		visual: 'optics',
		isVisible: (state) => true,
		features: [
			'root::Heads::Head::EBlock::EB_Control',
			'root::Heads::Head::EBlock::EB_ElectricalProtectionClass',
			'root::Heads::Head::SmartControl::HS_HousingZhaga',
			'root::Heads::Head::EBlock::EB_ConstantLumenTechnology'
		],
		widgets: []
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];
export const lineSingularIntern = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		isVisible: (state) => true,
		features: [
			'shared::ContextV3::CX_Region',
			'shared::ContextV3::CX_Usage',
			'shared::ProductType::HS_HousingType',
			'root::Poles::Pole::SpecialLine::HS_Construction',

			'shared::PreFilter::LU_Filter_LightEmission_Uplight',
			'shared::PreFilter::LU_Filter_LightEmission_CA',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_CA',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
			//'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightEmission_CA',
		],
		widgets: []
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'model',
		isVisible: (state) => true,
		features: [
			//'root::Poles::Pole::Basic::HS_Base',
			'root::Poles::Pole::Basic::HS_Height',
			'root::Poles::Pole::ColourCoatingBase::HS_HousingColour',
			'root::Poles::Pole::ColourCoatingBase::HS_HousingCoating',
			//'root::Heads::Head::Housing::HS_HousingShape',
			//'shared::HousingLuminaire::HS_HousingHeight',
			'root::Poles::Pole::Basic::HS_NumberPoleDoors',
			'root::Heads::Head::Housing::HS_HousingConnection',
			'root::Heads::Head::Housing::HS_HousingPowerConnection'],
		widgets: []
	},
	{
		id: 'lightengineA',
		label: {
			de: 'Optik A',
			en: 'Optics A',
			fr: 'Optique A',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ColourTemperature',
			//'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightDistribution',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LuminousFlux',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEngineModuleSize',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_OpticalVersion',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ReflectorColour',
		],
		widgets: []
	},
	{
		id: 'electricA',
		label: {
			de: 'EBlock A',
			en: 'EBlock A',
			fr: 'EBlock A',
		},
		visual: 'housing',
		isVisible: (state) => true,
		features: [
			'root::Heads::Head::EBlock::EB_ConstantLumenTechnology',
			'root::Heads::Head::EBlock::EB_Control',
			'root::Heads::Head::EBlock::EB_EBlockMountingType',
			'root::Heads::Head::EBlock::EB_ElectricalProtectionClass',
			'root::Heads::Head::EBlock::EB_Wattage',
			'root::Heads::Head::SmartControl::HS_HousingZhaga'
		],
		widgets: []
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		isVisible: (state) => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];

